module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"header":{"name":"항목","current_reward":"현재 적립금","max_reward":"최대 적립금"},"footer":{"name":"합계"}}}')
  delete Component.options._Ctor
}
